import { TableBody } from '@ksyos/design-system';
import type { EpisodeCategory } from '../../../../../../common/enums';
import type { IEmploymentAndServiceRights } from '../ServiceOrganizationPractitioners';
import { PractitionerTableRow } from './ServiceOrganizationPractitionerTableRow';

export interface IPractitionerTableProps {
    employments: IEmploymentAndServiceRights[];
    episodeCategory: EpisodeCategory;
    partitionEmployments: IEmploymentAndServiceRights[];
}

export function PractitionerTableBody(props: Readonly<IPractitionerTableProps>) {
    const { employments, partitionEmployments } = props;

    return <TableBody>{renderRows()}</TableBody>;

    function renderRows() {
        const employmentsToRender = employments ? partitionEmployments : [];

        return employmentsToRender.map((employment) => (
            <PractitionerTableRow
                employment={employment}
                key={employment.id}
                {...props}
            />
        ));
    }
}
